import { useContext, useEffect, useState, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, styled } from '@mui/material';

import { ctxUser } from '@/contexts/UserContext';

export function NewFeatureBadge({
  releaseDate,
  top,
  right,
  children,
}: {
  releaseDate: string | Date;
  top?: string;
  right?: string;
  children: ReactNode;
}) {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();
  const userCtx = useContext(ctxUser);
  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      backgroundColor: theme.palette.error.main,
      opacity: '90%',
      color: '#fff',
      fontSize: '0.7rem',
      fontWeight: 500,
      minWidth: 20,
      height: 20,
      padding: '0 4px',
      borderRadius: 10,
      boxShadow: theme.shadows[2],
      top: top ? `${top} !important` : '-1px !important',
      right: right ? `${right} !important` : '2px !important',
    },
  }));

  useEffect(() => {
    const now = new Date();
    const start = new Date(releaseDate);
    const expires = new Date(start);
    const durationDays = 31;
    expires.setDate(start.getDate() + durationDays);

    setIsVisible(now <= expires);
  }, [releaseDate]);

  if (!isVisible || userCtx?.isToken()) {
    return <>{children}</>;
  }

  return (
    <StyledBadge
      badgeContent={t('general.new')}
      overlap="circular"
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      {children}
    </StyledBadge>
  );
}
